<template>
  <div class="general-article-container">
    <article ref="introContainer">
      <div class="article article-main-pal" ref="introMainContainer" v-html="processHtml(articleContent)"></div>
    </article>
  </div>
</template>

<script>
const WINDOW_WIDTH = Math.min(window.innerWidth, 640);

export default {
  name: 'camp-intro',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    url: {
      type: String,
      default: ''
    },
    articleContent: {
      type: String,
      default: '',
    },
  },
  computed: {
    articleWidth() {
      return WINDOW_WIDTH - 16 * 2;
    },
  },
  data() {
    return {
      finished: true,
      imageSizes: {},
      imageId: 0,
    };
  },
  mounted() {
  },
  methods: {
    processHtml(html) { // 处理原来富文本 替换html的图片
      html = html.replace(/<img [^>]*style=['"]([^'"]+)[^>]*>/gi, (match, capture) => {
        // capture,返回每个匹配的字符串  match,返回img标签
        match = match.replace(`style="${capture}"`, '');
        return match;
      });
      html = html.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, (match, capture) => {
        // capture,返回每个匹配的字符串  match,返回img标签
        const widthPattern = new RegExp('\\sdata-width=[\'"](.*?)[\'"]');
        const heightPattern = new RegExp('\\sdata-height=[\'"](.*?)[\'"]');
        // const originPattern = new RegExp('\\sdata-origin=[\'"](.*?)[\'"]');

        const matchWidth = match.match(widthPattern);
        const matchHeight = match.match(heightPattern);
        // const origin = match.match(originPattern);

        if (window.location.protocol === 'https:') {
          match = match.replace('http://', 'https://');
        }
        let sizeUrl = capture.split('?')[0];

        // if (origin && origin === '1') {
        //   match = match.replace(/\sheight=/, ` style="max-width: none;" large="${sizeUrl}" data-pswp-uid="1" height=`);
        //   return match;
        // }

        if (matchWidth && matchHeight) {
          const realWidth = matchWidth[1];
          const realHeight = matchHeight[1];

          // 兼容 auto 的情况
          if (realHeight === 'auto' || realWidth === 'auto') {
            match = match.replace(/\sheight=/, ` style="max-width: 100%; height: auto; object-fit: cover;" large="${sizeUrl}" data-pswp-uid="1" height=`);
            return match;
          }
          const aWidth = Math.min(realWidth, this.articleWidth);
          const aHeight = Math.floor(realHeight * aWidth / realWidth);

          match = match.replace(/\sheight=/, ` style="width: ${aWidth}px; height: ${aHeight}px; object-fit: cover;" large="${sizeUrl}" data-pswp-uid="1" class="img-loading" height=`);
          if (sizeUrl.indexOf('alcdn.yojiang.cn') > -1) {
            sizeUrl = `${sizeUrl}?x-oss-process=image/resize,w_${aWidth}`;
            // console.log('sizeUrl -- x-oss-process', sizeUrl);
            match = match.replace(/\ssrc=/, ` src="${sizeUrl}"`);
          }
          return match;
        }

        sizeUrl = process.env.NODE_ENV !== 'development' ? sizeUrl : sizeUrl.replace('http://talcdn.jhkong.com', '');

        if (sizeUrl.indexOf('alcdn.yojiang.cn') > -1) {
          sizeUrl = `${sizeUrl}?x-oss-process=image/resize,w_${this.articleWidth}`;
          // console.log('sizeUrl -- x-oss-process', sizeUrl);
          match = match.replace(/\ssrc=/, ` src="${sizeUrl}"`);
        }
        return match;
      });
      this.finished = false;
      return html;
    },
    stripProtocol(url) {
      if (!url) return url;
      return url.replace('http:', '').replace('https:', '');
    },
  },

};
</script>

<style lang="stylus" scoped>
  @import "./../../common/stylus/variable.styl"

  .general-article-container {
    .article-cover-zone {
      position: relative
      padding-top: 56%
      overflow: hidden
      .cover-img {
        position: absolute
        top: 0
        left: 0
        right: 0
        bottom: 0
        display: block
        width: 100%
        height: 100%
        margin: auto
        object-fit cover
      }
    }
    .article-title {
      position: relative
      display: block
      margin 16px 16px 4px
      word-wrap: break-word
      line-height: 30px
      color: $color-text;
      font-size: 20px;
      font-weight: 800
      text-align: justify;
    }
    .hr-line {
      margin: 0 24px
      height: 1px
      background-color: #F2F2F2
    }
  }

  .article {
    margin: 20px 16px;
    font-size: 16px
    line-height: 28px
  }

  .user-wrap {
    padding 24px 16px
  }

</style>
